import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import CustomAnimation from '../animation/customAnimation';

let platformNav = jQuery('.platform_nav');
//const customAnmation = new CustomAnimation();
//let videoSrc;

class Platform {
  init() {
    this.initPage();
    //this.initVideo();
    this.initParallax();
    //this.onScroll();

    this.handleHashOnLoad();
  }

  initPage = () => {

  }

  initVideo = () => {
    // Add click event listener to all elements with class "video-btn"
    document.querySelectorAll('.preview-video').forEach(button => {
      button.addEventListener('click', () => {
        // Get the video source from the data-src attribute
        //videoSrc = button.dataset.src;
        $('#header_video').get(0).pause();
        $('#header_video').get(0).currentTime = 0;
      });
    });

    // Add event listener for when the modal is opened
    document.getElementById('videoModal').addEventListener('shown.bs.modal', () => {
      // Update the video source with autoplay and other options
      //document.getElementById('video').src = videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0";
      $('#header_video').get(0).play();
    });

    // Add event listener for when the modal is closed
    document.getElementById('videoModal').addEventListener('hide.bs.modal', () => {
      // Stop the video by resetting the source
      //document.getElementById('video').src = videoSrc;
      $('#header_video').get(0).pause();
    });
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    //customAnmation.animateHeaderImage('.header_background');

    // explained_background
    //customAnmation.animateBgImage('.explained_background', '.explained');
    //customAnmation.animateFromLeft('.explained_image');
    //customAnmation.animateFromRight('.explained_text');

    //customAnmation.animateBgImage('.market_background', '.market');
    //customAnmation.animateScaleDown('.market_image');
    //customAnmation.animateText('.market_text');
    //customAnmation.animateButtonHolder('.button_holder_market');

    //customAnmation.animateBgImage('.tools_background', '.tools');
    //customAnmation.animateScaleDown('.tools_image');
    //customAnmation.animateText('.tools_text');
    //customAnmation.animateButtonHolder('.button_holder_tools');

    //customAnmation.animateBgImage('.marinecore_background', '.marinecore');
    //customAnmation.animateBgImage('.marinecore_image', '.marinecore');
    //customAnmation.animateText('.marinecore_text');
    //customAnmation.animateButtonHolder('.button_holder_marinecore');

    //customAnmation.animateBgImage('.negotation_background', '.negotation');
    //customAnmation.animateBgImage('.negotation_image', '.negotation');
    //customAnmation.animateText('.negotation_text');
    //customAnmation.animateButtonHolder('.button_holder_marinecore');

    //customAnmation.animateBgImage('.analytics_background', '.analytics');
    //customAnmation.animateScaleDown('.analytics_image');
    //customAnmation.animateText('.analytics_text');
    //customAnmation.animateButtonHolder('.button_holder_analytics');

    //customAnmation.animateBgImage('.contact_background', '.contact');
    //customAnmation.animateScaleDown('.contact_form');
    //customAnmation.animateText('.contact_text');

  }

  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        let scrollPos = $(document).scrollTop();
        let positionTop1 = jQuery('#explained').offset().top - 100;
        let positionTop2 = jQuery('#market').offset().top - 100;
        let positionTop3 = jQuery('#tools').offset().top - 100;
        let positionTop4 = jQuery('#mydata').offset().top - 100;
        let positionTop5 = jQuery('#negotations').offset().top - 100;
        let positionTop6 = jQuery('#analytics').offset().top - 100;
        let positionTop7 = jQuery('#contact').offset().top - 100;
        var posTop = positionTop1 - 100;

        // show & hide nav

        if(scrollPos >= posTop) {
          platformNav.addClass('show');
        }
        else {
          platformNav.removeClass('show');
        }


        jQuery('.platform_nav_item a').removeClass("active");

        if(scrollPos >= positionTop1 && scrollPos < positionTop2)
        {
          jQuery('.platform_nav_item:nth-child(2) a').addClass("active");
        }

        if(scrollPos >= positionTop2 && scrollPos < positionTop3)
        {
          jQuery('.platform_nav_item:nth-child(3) a').addClass("active");
        }

        if(scrollPos >= positionTop3 && scrollPos < positionTop4)
        {
          jQuery('.platform_nav_item:nth-child(4) a').addClass("active");
        }

        if(scrollPos >= positionTop4 && scrollPos < positionTop5)
        {
          jQuery('.platform_nav_item:nth-child(5) a').addClass("active");
        }

        if(scrollPos >= positionTop5 && scrollPos < positionTop6)
        {
          jQuery('.platform_nav_item:nth-child(6) a').addClass("active");
        }

        if(scrollPos >= positionTop6 && scrollPos < positionTop7)
        {
          jQuery('.platform_nav_item:nth-child(7) a').addClass("active");
        }

      })
      .scroll();
  };

  handleHashOnLoad = () => {
    const offset = 100;

    // Prüfen ob ein Hash in der URL vorhanden ist
    if (window.location.hash) {
      const hash = window.location.hash;
      const target = jQuery(hash);

      if (target.length) {
        // Kurze Verzögerung, damit die Seite vollständig geladen ist
        setTimeout(() => {
          const targetPosition = target.offset().top - offset;

          jQuery('html, body').animate({
            scrollTop: targetPosition
          }, 800);
        }, 100);
      }
    }
  };
}

export default Platform;
